module.exports = __webpack_public_path__ + "img/icon5.c3b90248.png";